import 'react-modal-video/scss/modal-video.scss';
import {Col, Row, Carousel} from "react-bootstrap";
import MotionDiv from "../motionDiv";
import {useCallback, useEffect, useState} from "react";
import partnersData from "../../data/partnersData";

function TrustBlock() {
    const [groupedItems, setGroupedItems] = useState([]);

    const chunkArray = (array, size) =>
        array.reduce((acc, _, i) => (i % size ? acc : [...acc, array.slice(i, i + size)]), []);

    const updateGroupedItems = useCallback(() => {
        const isMobile = window.innerWidth < 768;
        const chunkSize = isMobile ? 2 : 5;
        setGroupedItems(chunkArray(partnersData, chunkSize));
    }, []);

    useEffect(() => {
        updateGroupedItems();
        window.addEventListener('resize', updateGroupedItems);
        return () => window.removeEventListener('resize', updateGroupedItems);
    }, [updateGroupedItems]);


    return (
        <section id="trust" className="trust-section layout-pt-60 js-tab-menu-content">
            <div className="auto-container">
                <Row>
                    <Col lg={12}>
                        <MotionDiv delay={0.3}>
                            <div className="sec-title">
                                <h2>
                                    Ils nous font confiance !
                                </h2>
                            </div>
                        </MotionDiv>
                    </Col>
                    <Col lg={12}>
                        <MotionDiv delay={0.5} duration={0.6} variant={'zoomIn'}>
                            <Carousel
                                interval={3000}
                                controls={true}
                                indicators={false}
                                pause="hover">
                                {groupedItems.map((group, index) => (
                                    <Carousel.Item key={`carousel-${index}`}>
                                        <div className="d-flex justify-content-center gap-3">
                                            {group.map((item, i) => (
                                                <div key={`carousel-item-${i}`}
                                                     className="d-flex align-items-center justify-content-center">
                                                    <img className="carousel-picture"
                                                         src={`/images/trust1/${item.picture}`}
                                                         alt={item.title}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </Carousel.Item>
                                ))}
                            </Carousel>
                        </MotionDiv>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default TrustBlock;
